/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StatusService {
    /**
     * Get combined status information for all entities
     * Main dashboard endpoint that provides a comprehensive overview of all entity statistics
     * @param startDate Start date for filtering (YYYY-MM-DD)
     * @param status Filter shipments by status
     * @param state Filter packages by state
     * @param isShipped Filter packages by shipped status
     * @param isCombined Filter packages by combined status
     * @param isDraft Filter packages by draft status
     * @param isReceived Filter expected packages by received status
     * @returns any Successfully retrieved combined statistics
     * @throws ApiError
     */
    public static getStatus(
        startDate?: string,
        status?: 'REQUESTED' | 'APPROVED',
        state?: 'DRAFT' | 'REQUESTED' | 'APPROVED' | 'DONE',
        isShipped?: boolean,
        isCombined?: boolean,
        isDraft?: boolean,
        isReceived?: boolean,
    ): CancelablePromise<{
        success?: boolean;
        data?: {
            summary?: {
                totalShipments?: number;
                totalPackages?: number;
            };
            shipments?: {
                total?: number;
                byState?: {
                    REQUESTED?: number;
                    APPROVED?: number;
                };
                financials?: {
                    averageCost?: number;
                    totalRevenue?: number;
                };
            };
            packages?: {
                total?: number;
                shippedCount?: number;
                combinedCount?: number;
                draftCount?: number;
                averageStats?: {
                    weight?: number;
                    dimensions?: {
                        length?: number;
                        width?: number;
                        height?: number;
                    };
                    shippingCost?: number;
                };
            };
            expectedPackages?: {
                total?: number;
                receivedCount?: number;
                pendingCount?: number;
            };
            combinedPackages?: {
                total?: number;
                byState?: {
                    DRAFT?: number;
                    REQUESTED?: number;
                    APPROVED?: number;
                    DONE?: number;
                };
            };
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/status',
            query: {
                'startDate': startDate,
                'status': status,
                'state': state,
                'isShipped': isShipped,
                'isCombined': isCombined,
                'isDraft': isDraft,
                'isReceived': isReceived,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get shipment statistics
     * @param startDate Start date for filtering (YYYY-MM-DD)
     * @param endDate End date for filtering (YYYY-MM-DD)
     * @param status Filter shipments by status
     * @param state Filter shipments by state (alias for status)
     * @returns any Successfully retrieved shipment statistics
     * @throws ApiError
     */
    public static getStatusShipments(
        startDate?: string,
        endDate?: string,
        status?: 'REQUESTED' | 'APPROVED',
        state?: 'REQUESTED' | 'APPROVED',
    ): CancelablePromise<{
        success?: boolean;
        data?: {
            total?: number;
            byState?: {
                REQUESTED?: number;
                APPROVED?: number;
            };
            financials?: {
                averageCost?: number;
                totalRevenue?: number;
            };
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/status/shipments',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'status': status,
                'state': state,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get package statistics
     * Retrieves statistics about packages with various filtering options
     * @param startDate Start date for filtering (YYYY-MM-DD)
     * @param endDate End date for filtering (YYYY-MM-DD)
     * @param state Filter packages by state
     * @param isShipped Filter packages by shipped status (true/false)
     * @param isCombined Filter packages by combined status (true/false)
     * @param isDraft Filter packages by draft status (true/false)
     * @returns any Successfully retrieved package statistics
     * @throws ApiError
     */
    public static getStatusPackages(
        startDate?: string,
        endDate?: string,
        state?: string,
        isShipped?: boolean,
        isCombined?: boolean,
        isDraft?: boolean,
    ): CancelablePromise<{
        success?: boolean;
        data?: {
            total?: number;
            shippedCount?: number;
            combinedCount?: number;
            draftCount?: number;
            averageStats?: {
                weight?: number;
                dimensions?: {
                    length?: number;
                    width?: number;
                    height?: number;
                };
                shippingCost?: number;
            };
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/status/packages',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'state': state,
                'isShipped': isShipped,
                'isCombined': isCombined,
                'isDraft': isDraft,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get expected package statistics
     * Retrieves statistics about expected packages with filtering by received status
     * @param startDate Start date for filtering (YYYY-MM-DD)
     * @param endDate End date for filtering (YYYY-MM-DD)
     * @param isReceived Filter expected packages by received status (true/false)
     * @returns any Successfully retrieved expected package statistics
     * @throws ApiError
     */
    public static getStatusExpectedPackages(
        startDate?: string,
        endDate?: string,
        isReceived?: boolean,
    ): CancelablePromise<{
        success?: boolean;
        data?: {
            total?: number;
            receivedCount?: number;
            pendingCount?: number;
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/status/expected-packages',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'isReceived': isReceived,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get combined package statistics
     * @param startDate Start date for filtering (YYYY-MM-DD)
     * @param endDate End date for filtering (YYYY-MM-DD)
     * @param state Filter combined packages by state
     * @returns any Successfully retrieved combined package statistics
     * @throws ApiError
     */
    public static getStatusCombinedPackages(
        startDate?: string,
        endDate?: string,
        state?: 'DRAFT' | 'REQUESTED' | 'APPROVED' | 'DONE',
    ): CancelablePromise<{
        success?: boolean;
        data?: {
            total?: number;
            byState?: {
                DRAFT?: number;
                REQUESTED?: number;
                APPROVED?: number;
                DONE?: number;
            };
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/status/combined-packages',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'state': state,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get graph data for visualizing statistics
     * Provides data for generating various types of graphs and charts for dashboard visualization
     * @param type Type of graph data to generate
     * @param startDate Start date for filtering (defaults to 6 months ago for time-series, 3 months ago for others)
     * @param endDate End date for filtering (defaults to current date)
     * @param period Time grouping for time-series graphs
     * @param includePackages Include package data in time-series
     * @param includeShipments Include shipment data in time-series
     * @param includeCombined Include combined package data in time-series
     * @param includeExpected Include expected package data in time-series
     * @param entityType Entity type for distribution graphs
     * @param focus Focus entity for status breakdown graphs
     * @returns any Successfully retrieved graph data
     * @throws ApiError
     */
    public static getStatusGraph(
        type: 'time-series' | 'distribution' | 'status-breakdown' = 'time-series',
        startDate?: string,
        endDate?: string,
        period: 'day' | 'week' | 'month' | 'year' = 'month',
        includePackages: boolean = true,
        includeShipments: boolean = true,
        includeCombined: boolean = true,
        includeExpected: boolean = true,
        entityType: 'all' | 'package' | 'shipment' | 'combined' = 'all',
        focus: 'package' | 'shipment' | 'combined' = 'package',
    ): CancelablePromise<({
        labels?: Array<string>;
        series?: Record<string, Record<string, number>>;
    } | {
        package?: Record<string, any>;
        shipment?: Record<string, any>;
        combinedPackage?: Record<string, any>;
    } | {
        total?: number;
        draft?: number;
        processed?: number;
        combined?: number;
        shipped?: number;
        standalone?: number;
    })> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/status/graph',
            query: {
                'type': type,
                'startDate': startDate,
                'endDate': endDate,
                'period': period,
                'includePackages': includePackages,
                'includeShipments': includeShipments,
                'includeCombined': includeCombined,
                'includeExpected': includeExpected,
                'entityType': entityType,
                'focus': focus,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal server error`,
            },
        });
    }
}
